module.exports = __webpack_public_path__ + "assets/img/footer_sukikamo.04fc3c2a.svg";